import moment from 'moment';

/**
 * Reguli comune pentru evidenta stocurilor, folosite de listare, de pagina
 * lotului si de etichete.
 */

const STOCK_IN = 'in';
const STOCK_OUT = 'out';
const STOCK_UNINVENTORIED = 'uninventoried';

/**
 * Lipsa campului `inStock` inseamna ca lotul nu a fost scanat niciodata, deci
 * nu stim unde se afla. Nu este acelasi lucru cu "a iesit din stoc".
 */
export function stockStateOf(lot: any): string {
    // Orice altceva decat un boolean (camp lipsa sau null din Mongo) inseamna
    // ca lotul nu a fost inventariat inca.
    if (!lot || typeof lot.inStock !== 'boolean') {
        return STOCK_UNINVENTORIED;
    }

    return lot.inStock ? STOCK_IN : STOCK_OUT;
}

function isInStock(lot: any): boolean {
    return stockStateOf(lot) === STOCK_IN;
}

/*
 * Actiunile se ofera explicit, nu ca o comutare: un lot neinventariat poate fi
 * marcat direct si ca iesit din stoc (obiect predat, returnat sau pierdut
 * inainte de prima scanare), fara sa fie nevoie sa-l bagi intai in stoc - ceea
 * ce ar scrie o intrare falsa in istoric.
 */
export function canSetInStock(lot: any): boolean {
    return !isInStock(lot);
}

export function canSetOutOfStock(lot: any): boolean {
    return stockStateOf(lot) !== STOCK_OUT;
}

export function stockLabel(lot: any): string {
    switch (stockStateOf(lot)) {
        case STOCK_IN:
            return 'In stoc';
        case STOCK_OUT:
            return 'Iesit din stoc';
        default:
            return 'Neinventariat';
    }
}

/**
 * Clasele badge-ului de stare. Nu folosim variantele bootstrap ale temei:
 * `badge-secondary` este text alb pe gri deschis (contrast 1,3:1), deci
 * ilizibil. Culorile proprii sunt in `_stock.scss`, verificate la peste
 * 4,5:1 fata de alb.
 */
export function stockBadgeClass(lot: any): string {
    switch (stockStateOf(lot)) {
        case STOCK_IN:
            return 'badge-stoc is-in';
        case STOCK_OUT:
            return 'badge-stoc is-out';
        default:
            return 'badge-stoc is-unknown';
    }
}

/** Codul intern afisat peste tot in admin. */
export function formatSku(sku: any): string {
    return sku ? `VIK-${sku}` : '';
}

/** "435-a / 26.06.2026" - numarul asa cum apare pe contractul semnat. */
export function formatContractNumber(contract: any): string {
    if (!contract || !contract.number) return '';

    const number = `${contract.number}${
        contract.suffix ? '-' + contract.suffix : ''
    }`;

    if (!contract.signedAt) return number;

    return `${number}/${moment(contract.signedAt).format('DD.MM.YYYY')}`;
}

/**
 * Adresa codificata in QR-ul de pe eticheta. Merge pe radacina cu parametru
 * pentru ca adminul este servit static: doar `/` este garantat rezolvabil,
 * iar garda din router rescrie catre `/stocuri/lot/<sku>`.
 */
export function stockLabelUrl(sku: any): string {
    const base = process.env.ADMIN_URL || window.location.origin;
    return `${base}/?stoc=${sku}`;
}

/**
 * Inversul lui `stockLabelUrl`, pentru pagina de scanare: SKU-ul din adresa
 * codului QR sau din codul scris de mana ori trimis de un cititor de coduri
 * (`VIK-1234`, `1234`).
 */
export function skuFromCode(code: string): number | undefined {
    const text = String(code || '').trim();
    const match =
        text.match(/[?&]stoc=(\d+)/i) || text.match(/^(?:vik-?)?(\d+)$/i);

    return match ? parseInt(match[1], 10) : undefined;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/stock.ts